// 同步淘宝订单
import synchTmallNo from "widget/orderButtonGroup/synchTmallNo";
// 二次确认
import secondaryConfirm from "widget/orderButtonGroup/secondaryConfirm";
// 批量发货
import sendGoods from "widget/orderButtonGroup/sendGoods";
// 批量签名
import signs from "widget/orderButtonGroup/signs";
import modify from "widget/orderButtonGroup/modify";
import mergelist from "widget/orderButtonGroup/mergelist";
import additionalist from "widget/orderButtonGroup/additionalist";
// 批量二次检查
import secondaryCheck from "widget/orderButtonGroup/secondaryCheck";
// 批量售后
import afterSale from "widget/orderButtonGroup/afterSale";
// 分配订单
import allocationOrder from "widget/orderButtonGroup/allocationOrder";
// 导出Excel
import exportExcel from "widget/orderButtonGroup/exportExcel";

import unsubscribel from "widget/orderButtonGroup/unsubscribe";
import nounsubscribel from "widget/orderButtonGroup/nounsubscribe";
import verify from "widget/orderButtonGroup/verify";

export const SynchTmallNo = synchTmallNo;

export const SecondaryConfirm = secondaryConfirm;

export const SendGoods = sendGoods;

export const Signs = signs;

export const Modify = modify;
export const Mergelist = mergelist;
export const Additionalist = additionalist;

export const SecondaryCheck = secondaryCheck;

export const AfterSale = afterSale;

export const AllocationOrder = allocationOrder;

export const ExportExcel = exportExcel;
export const Unsubscribel = unsubscribel;
export const Nounsubscribel = nounsubscribel;
export const Verify = verify;